import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-list",
  "use": "svg_i-list-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"svg_i-list\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 14v-2h14v2H0zm0-8h14v2H0V6zm0-6h14v2H0V0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol